import { getNotificationPublishState, Notification } from '../../../../models';
import classes from './DeliveryTimeText.module.scss';
import getFormattedDate from '../../../../helpers/getFormattedDate';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.dialogs.publishNotificationConfirm.deliveryTimeText';

const DeliveryTimeText = ({ notification, environmentId }: { notification: Notification; environmentId: string }) => {
    const { t } = useTranslation('', { keyPrefix });
    const notificationPublishState = getNotificationPublishState(notification, environmentId);

    const startAt = useMemo(
        () => (notificationPublishState?.startAt ? new Date(notificationPublishState?.startAt) : notificationPublishState?.startAt),
        [notificationPublishState?.startAt]
    );
    const endAt = useMemo(() => (notificationPublishState?.endAt ? new Date(notificationPublishState?.endAt) : notificationPublishState?.endAt), [
        notificationPublishState?.endAt
    ]);
    const isInAudienceLocalTimezone = notificationPublishState?.scheduling?.audienceTimeZone;

    const isScheduled = startAt && startAt > new Date();

    return (
        <div className={classes.scheduledText}>
            <div>
                <span className={classes.firstCap}>{isScheduled ? `${getFormattedDate(startAt)} - ${getFormattedDate(endAt)}` : t('now')}</span>
            </div>
            {isInAudienceLocalTimezone && (
                <div className={classes.firstCap}>{t('inLocalTZ')}</div>
            )}
        </div>
    );
};

export default DeliveryTimeText;
